var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-participation"},[_c('exerciseHeader'),_c(_vm.pageComponent,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }